import { triggerBrowserDownload } from './jobLinkHelpers';

const REVOKE_OBJECT_URL_DELAY_MS = 1_000;

export const downloadBlobResponseAsFile = (data: BlobPart, filename: string): void => {
  const url = URL.createObjectURL(data instanceof Blob ? data : new Blob([data]));
  triggerBrowserDownload(url, filename);
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_OBJECT_URL_DELAY_MS);
};
